import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { RestService } from 'src/app/shared/service/rest.service';
import { TenantInfo } from '../model/tenant-info';
import { SessionStorageService } from 'src/app/common/service/session-storage.service';
import { SakpModuleUtils } from '../sakp-module-utils';
import { ContractInfo } from '../model/contract';

@Injectable()
export class ContractService extends RestService {
    public static readonly SOURCE = 'contracts';
    private static readonly STORAGE_NAME = 'sakp-contracts';
    private dataSubject: BehaviorSubject<ContractInfo[]> = new BehaviorSubject([]);

    constructor(http: HttpClient, private sessionStorageService: SessionStorageService) {
        super(http);
        this.serverUrl = SakpModuleUtils.getSakpServerUrl();
        const data = this.sessionStorageService.getItemArray<ContractInfo>(ContractService.STORAGE_NAME, ContractInfo);
        if (data != null)
            this.dataSubject.next(data);
    }

    initiate(tenant: TenantInfo): Observable<ContractInfo[]> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return this.doGet('api/v1/dict/contracts', null, { 'X-Tenant-ID': tenant.id.toString() })
            .pipe(
                timeout(5000),
                map((res: any[]) => plainToClass(ContractInfo, res)),
                tap(res => {
                    this.dataSubject.next(res);
                    this.sessionStorageService.setItem(ContractService.STORAGE_NAME, res);
                }),
                catchError(err => {
                    this.dataSubject.next([]);
                    this.sessionStorageService.setItem(ContractService.STORAGE_NAME, []);
                    err.source = ContractService.SOURCE;
                    return throwError(err);
                })
            );
    }

    getAll(): ContractInfo[] {
        return this.dataSubject.getValue() || [];
    }

    clear(): void {
        this.sessionStorageService.setItem(ContractService.STORAGE_NAME, []);
        this.dataSubject.next([]);
    }
}
